import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpResponse
} from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { AuthService } from '@core/auth.service';
import { CommonService } from '../modules/shared/services/common.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { appRoutingUrl } from '../enums/comman.enums';
import { hasWhiteLabelConfig } from '@utils/common.utils';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const cs = inject(CommonService);
  const location = inject(Location);
  const router = inject(Router);

  if (req.urlWithParams.includes('skipInterceptor=true')) {
    return next(req);
  }
  const clonedRequest = req.clone();
  return next(clonedRequest).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        if (event?.status === 401) {
          cs.logoutUser();
          return;
        }
        if(event.url && (event.url.includes('/users/users?host_name'))){
          const res = event.body as any;
          if(res?.data?.is_creator_logout && !authService.userContext?.fm_user){
            cs.logoutUser();
          }
        }
        if(event.url && (event.url.includes('/user_by_username'))) {
          const res = event.body as any;
          if (res?.data?.is_suspended || res?.data?.is_paused) {
            cs.showSuspendedPage(cs.getUserId());
          } else if (isNotOnActivityHomeProfile(location.path()) && (res?.data?.is_private || (!hasWhiteLabelConfig() && res?.data?.only_followers_can_access_content)) && !res?.data?.is_follower) {
            router.navigate(['', res?.data?.user_name]);
          }
        }
      }
    })
  );
};

function isNotOnActivityHomeProfile(currentBrowserURL: string): boolean {
  return !([appRoutingUrl.DASHBOARD_ACTIVITY, appRoutingUrl.DASHBOARD_POSTS].some(path => currentBrowserURL?.includes(path)) || !currentBrowserURL?.slice(1)?.includes('/'));
}
